import {
  SET_SEARCH_VAL,
  SET_FILTER_VISIBLE,
  SET_SELECTED_QUESTION,
  SET_PERIOD,
  SET_TYPES,
  SET_STATES,
  SET_COMPANIES,
  SET_STREETS,
  SET_HOUSES,
  SET_ADDRESSES,
  RESET_FILTER,
  SET_IS_HTML,
  SET_LOCAL_FILES,
  SET_EDITOR_STATE,
  SET_EDITOR_LINK_MODAL_DATA,
  SET_MESSAGE_AREA_STATE,
  RESET_AREA_EDITOR_STATES,
  SET_ANSWER_STATUS,
  SET_CLOSE_QUESTION_REJECTED,
  RESET_QUESTIONS_STORE,
  SET_QUESTIONS_SORT_DATA,
  SET_QUESTIONS_SAVED_DATA,
  SET_IMPORTANT_QUESTIONS_FIRST,
  SET_QUESTION_REACTION,
  SET_NOTIFICATION_QUESTION,
  SET_EDITOR_PHONE_MODAL_DATA
} from './actionsTypes';

export const setSearchVal = (val) => ({
  type: SET_SEARCH_VAL,
  payload: val,
});

export const setFilterVisible = (booleanVal) => ({
  type: SET_FILTER_VISIBLE,
  payload: booleanVal,
});

export const setSelectedQuestion = (question) => ({
  type: SET_SELECTED_QUESTION,
  payload: question,
});

export const setPeriod = (period) => ({
  type: SET_PERIOD,
  payload: period,
});

export const setTypes = (types) => ({
  type: SET_TYPES,
  payload: types,
});

export const setStates = (states) => ({
  type: SET_STATES,
  payload: states,
});

export const setCompanies = (companies) => ({
  type: SET_COMPANIES,
  payload: companies,
});

export const setStreets = (streets) => ({
  type: SET_STREETS,
  payload: streets,
});

export const setHouses = (houses) => ({
  type: SET_HOUSES,
  payload: houses,
});

export const setAddresses = (addresses) => ({
  type: SET_ADDRESSES,
  payload: addresses,
});

export const resetFilter = () => ({
  type: RESET_FILTER,
});

export const setIsHtml = (booleanVal) => ({
  type: SET_IS_HTML,
  payload: booleanVal,
});

export const setLocalFiles = (files) => ({
  type: SET_LOCAL_FILES,
  payload: files,
});

export const setEditorState = (state) => ({
  type: SET_EDITOR_STATE,
  payload: state,
});

export const setEditorLinkModalData = (data) => ({
  type: SET_EDITOR_LINK_MODAL_DATA,
  payload: data,
});

export const setEditorPhoneModalData = (data) => ({
  type: SET_EDITOR_PHONE_MODAL_DATA,
  payload: data,
})

export const setMessageAreaState = (text) => ({
  type: SET_MESSAGE_AREA_STATE,
  payload: text,
});

export const resetAreaEditorStates = () => ({
  type: RESET_AREA_EDITOR_STATES,
});

export const setAnswerStatus = (status) => ({
  type: SET_ANSWER_STATUS,
  payload: status,
});

export const setQuestionReaction = (reactionName) => ({
  type: SET_QUESTION_REACTION,
  payload: reactionName,
});

export const setCloseQuestionRejected = (booleanVal) => ({
  type: SET_CLOSE_QUESTION_REJECTED,
  payload: booleanVal,
});

export const setQuestionsSortData = (sortData) => ({
  type: SET_QUESTIONS_SORT_DATA,
  payload: sortData,
});

export const setQuestionsSavedData = (savedData) => ({
  type: SET_QUESTIONS_SAVED_DATA,
  payload: savedData,
});

export const setImportantQuestionsFirst = (booleanVal) => ({
  type: SET_IMPORTANT_QUESTIONS_FIRST,
  payload: booleanVal,
});

export const setNotificationQuestion = (data) => ({
  type: SET_NOTIFICATION_QUESTION,
  payload: data,
});

export const resetQuestionsStore = () => ({
  type: RESET_QUESTIONS_STORE,
});
